// Configuration d'environnement runtime
export function getEnvironmentConfig() {
  const currentOrigin = window.location.origin;
  const isLocalhost = currentOrigin.includes('localhost') || currentOrigin.includes('127.0.0.1');
  
  // Configuration par défaut - toujours utiliser la même origine que le frontend
  // pour éviter les problèmes de CORS et de proxy
  const config = {
    socketUrl: currentOrigin,
    isDevelopment: !import.meta.env.PROD,
    isProduction: import.meta.env.PROD,
  };
  
  console.log('Environment config:', config);
  
  return config;
} 
